<template>
  <DBox
    :id="'cmp-distribution-statement-sidewindow-country'"
    :addButton="false"
    :addLink="false"
  >
    <!-- @add_click="onAddArtist" -->
    <!-- :expandable="true" -->
    <NTable
      class="dbox1"
      id="distribution-statement-country"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('country')">
            <span>{{ item['country'] }}</span>
          </td>
          <td v-bind="tdcon('imported_as')">
            <span>{{ item['imported_as'] }}</span>
          </td>
          <td v-bind="tdcon('net_sales')">
            <span>{{ item['net_sales'] }}</span>
          </td>

          
          <td v-bind="tdcon('turnover')">
            <span>{{ item['turnover'] }}</span>
          </td>

        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {
    selectedStatementDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("country", {}),
        createTableHeader("imported_as", {}),
        createTableHeader("net_sales", { ta:'right'}),
        createTableHeader("turnover", { ta:'right'}),
      ];
    },

    list: function() {
      return this.selectedStatementDetails.countries || [];
    },


  },
  methods: {
 
  }
};
</script>
<style lang="scss">
.cmp-distribution-statement-sidewindow-country {
  .dt-ntable tbody tr:last-child {
    border-bottom: 0;
  }
}
</style>